// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"383":"743ee88b","825":"47e4253f","920":"d876bfee"}[chunkId] + ".css";
};